import type { FileAPIPDFResponse, FileAPIResponse } from "./types";
import useFetchTax from "./use-fetch-tax";

export default function useFile(id?: string) {
  const {
    isLoading: useFetchTaxIsLoading,
    error: useFetchTaxError,
    create,
    get,
    remove,
  } = useFetchTax();

  const createFile = async (payload: FormData) => {
    const res = (await create("files", null, {
      body: payload,
    })) as FileAPIResponse;
    return res.data;
  };

  const getFilePDFURL = async (id: string) => {
    const res = (await get(`file/${id}/pdf`)) as FileAPIPDFResponse;

    return res.data.url;
  };

  const removeFile = async (id: string) => {
    return await remove(`file/${id}`);
  };

  return {
    isLoading: useFetchTaxIsLoading,
    error: useFetchTaxError,
    createFile: createFile,
    getFilePDFURL: getFilePDFURL,
    removeFile: removeFile,
  };
}
